import NavBarCta from '@components/molecules/navbar/NavBarCta';
import { useProfile } from '@hooks/api';
import { useLoadingModal } from '@hooks/useLoadingModal';
import { cn } from '@moreharvest/component-library';
import NavLinks from '../../molecules/navbar/NavLinks';
import NavLogo from '../../molecules/navbar/NavLogo';
import ContextMenu from './ContextMenu';

const desktopNavBarClasses = cn(
    'hidden w-full lg:flex px-[11.1%]',
    'items-center lg:justify-start lg:items-center lg:py-[30px]',
    'bg-neutral-50 dark:bg-neutral-50-dark'
);

const DesktopNavBar = () => {
    const { data: userProfile, isLoading } = useProfile();
    useLoadingModal(isLoading, 'DesktopNavBar');

    return userProfile ? (
        <div className={desktopNavBarClasses}>
            <NavLogo />
            <NavLinks />
            <div className="ml-auto self-end relative flex items-center gap-4">
                <ContextMenu cytag="desktop-nav" />
                <NavBarCta accountStatus={userProfile?.accountStatus} />
            </div>
        </div>
    ) : (
        <></>
    );
};

export default DesktopNavBar;
